import { GetCustomerByExternalReference } from "../queries/GetCustomerByExternalReference.core.js";
export const getCustomerByExternalReference = async ({ value, key = "phone" }, { client }) => {
    const data = await client.core.request(GetCustomerByExternalReference, {
        value,
        key,
    });
    if (!data?.customer) {
        return null;
    }
    if (data.customer.__typename == "UnknownError") {
        throw new Error(`Error getting customer by external reference (key: ${key}). ErrorName: ${data.customer.errorName}. Message: ${data.customer.message}`);
    }
    if (data.customer.__typename !== "Customer") {
        throw new Error(`Error getting customer by external reference (key: ${key}). Unexpected typename: ${data.customer.__typename}`);
    }
    return data.customer;
};
